const icon = require('vue-svgicon');
icon.register({
    'legal-entity-f': {
        width: 21,
        height: 20,
        viewBox: '0 0 21 20',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2.501 18.889h15.667c.862-1.332.518-3.998-.343-4.887-.402-.413-3.55-1.235-5-1.597 1.56-1.22 2.51-3.474 2.51-5.622 0-3.133-.91-5.672-5.002-5.672-4.093 0-5.003 2.54-5.003 5.672 0 2.154.956 4.414 2.524 5.632-1.485.365-4.586 1.165-5 1.587-.87.888-1.221 3.555-.353 4.887zm9.5-5.445c2.089.502 4.54 1.19 5.11 1.495.357.462.667 1.924.444 2.84H3.113c-.225-.916.092-2.383.455-2.84.561-.308 3-.984 5.1-1.479v-1.774c-1.395-.947-2.221-3.009-2.221-4.883 0-2.532.647-4.585 3.886-4.585 3.238 0 3.886 2.053 3.886 4.585 0 1.872-.826 3.933-2.219 4.881v1.76z" _fill="#000"/>`,
    },
});
